export enum ReferralMetaType {
  REFERRAL_VAULT_META = 'ReferralVaultMeta',
  REFERRAL_SETTLEMENT_META = 'ReferralSettlementMeta'
}
